import React from "react";
import "./styles.scss";

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Switching organization...",
}) => {
  return (
    <div className="loading-screen">
      <div className="loading-screen__content">
        <div className="loading-screen__spinner">
          <div className="loading-screen__spinner-circle"></div>
        </div>
        <div className="loading-screen__message">{message}</div>
      </div>
    </div>
  );
};

export default LoadingScreen;
